export default function block_teams() {
  if ($('.felds-teams-block').length == 0) return;

  $('.link-see-teams').click(function(e){
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top
    }, 800);
  });
}
